import React from "react";

const LightIconDark = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
    >
      <path
        d="M47.9999 36.5715C48.0106 33.7186 47.2582 30.9147 45.8209 28.4503C44.3835 25.986 42.3133 23.9507 39.8248 22.5555C37.3363 21.1603 34.5201 20.4558 31.6677 20.515C28.8154 20.5743 26.0308 21.3951 23.6024 22.8925C21.174 24.3898 19.1902 26.5092 17.8563 29.0312C16.5225 31.5531 15.8873 34.3858 16.0164 37.2358C16.1455 40.0858 17.0344 42.8495 18.5908 45.2404C20.1472 47.6314 22.3146 49.5627 24.8685 50.8343V58.6972C24.8804 59.1621 25.0735 59.6039 25.4065 59.9284C25.7396 60.253 26.1863 60.4345 26.6513 60.4344H37.3485C37.8135 60.4345 38.2602 60.253 38.5932 59.9284C38.9263 59.6039 39.1194 59.1621 39.1313 58.6972V50.6972C41.7656 49.3859 43.9872 47.3735 45.5518 44.8814C47.1165 42.3892 47.9635 39.5139 47.9999 36.5715Z"
        stroke="#09090B"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.9996 3.70276V10.5599M50.2853 10.2399L45.4396 15.1313M60.7082 24.4113H53.851M13.7139 10.2399L18.5596 15.1313M3.29102 24.4113H10.1482"
        stroke="url(#paint0_linear_3578_11419)"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3578_11419"
          x1="3.29102"
          y1="13.9433"
          x2="60.7082"
          y2="13.9433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#42E6FF" />
          <stop offset="1" stopColor="#8B5EF7" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LightIconDark;
